// Intentionally kept empty to disable direct access to the microfrontend url.
